import api from '../config/api';

const gratificacionService = {
  /**
   * Empleados elegibles para gratificación (es_boleta_liquidada=0; General, Pequeña o Minero)
   * GET /api/gratificaciones/empleados-elegibles?empresa_id=
   */
  getEmpleadosElegibles: async (empresaId) => {
    const response = await api.get('/gratificaciones/empleados-elegibles', {
      params: { empresa_id: empresaId },
    });
    return response.data;
  },

  /**
   * Períodos de gratificación disponibles (Junio/Diciembre según planillas cerradas)
   * GET /api/gratificaciones/periodos?empresa_id=&anio=
   */
  getPeriodos: async (empresaId, anio = new Date().getFullYear()) => {
    const response = await api.get('/gratificaciones/periodos', {
      params: { empresa_id: empresaId, anio },
    });
    return response.data;
  },

  /**
   * Calcular gratificación para un período (no persiste)
   * GET /api/gratificaciones/calcular?empresa_id=&periodo=junio|diciembre&anio=
   */
  calcular: async (empresaId, periodo, anio) => {
    const response = await api.get('/gratificaciones/calcular', {
      params: { empresa_id: empresaId, periodo, anio },
    });
    return response.data;
  },

  /**
   * Listar gratificaciones guardadas por empresa
   * GET /api/gratificaciones?empresa_id=&anio=&estado=
   */
  list: async (empresaId, anio = null, estado = null) => {
    const params = { empresa_id: empresaId };
    if (anio != null) params.anio = anio;
    if (estado != null) params.estado = estado;
    const response = await api.get('/gratificaciones', { params });
    return response.data;
  },

  /**
   * Obtener una gratificación con su detalle
   * GET /api/gratificaciones/{id}
   */
  getById: async (id) => {
    const response = await api.get(`/gratificaciones/${id}`);
    return response.data;
  },

  /**
   * Crear gratificación (ejecuta cálculo y guarda)
   * POST /api/gratificaciones
   */
  create: async (empresaId, periodo, anio) => {
    const response = await api.post('/gratificaciones', {
      empresa_id: empresaId,
      periodo: periodo === 'Junio' ? 'junio' : 'diciembre',
      anio: Number(anio),
    });
    return response.data;
  },

  /**
   * Cerrar gratificación
   * PUT /api/gratificaciones/{id}/cerrar
   * @param {boolean} entraraEnPlanilla - Si los montos se incluyen en planilla
   */
  cerrar: async (id, entraraEnPlanilla) => {
    const response = await api.put(`/gratificaciones/${id}/cerrar`, {
      entrara_en_planilla: entraraEnPlanilla === true,
    });
    return response.data;
  },

  /**
   * Reabrir gratificación
   * PUT /api/gratificaciones/{id}/abrir
   */
  abrir: async (id) => {
    const response = await api.put(`/gratificaciones/${id}/abrir`);
    return response.data;
  },

  /**
   * Eliminar gratificación (solo si está en proceso)
   * DELETE /api/gratificaciones/{id}
   */
  delete: async (id) => {
    const response = await api.delete(`/gratificaciones/${id}`);
    return response.data;
  },

  /**
   * Actualizar configuración editable de un detalle (meses excluidos, conceptos, montos)
   * PUT /api/gratificaciones/{gratificacionId}/detalles/{empleadoId}
   */
  updateDetalle: async (gratificacionId, empleadoId, payload) => {
    const response = await api.put(
      `/gratificaciones/${gratificacionId}/detalles/${empleadoId}`,
      payload
    );
    return response.data;
  },
};

export default gratificacionService;
